import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { getTextColor, getBackgroundColor, getBorderColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
const labelAlignment = {
  start: 'left',
  end: 'right',
  center: 'center'
};
export const Container = styled.div`
  position: relative;
`;
export const Label = styled.div`
  width: 100%;
  color: ${getTextColor('attributeLabel')};
  text-align: ${({
  bordered,
  alignment
}) => bordered ? 'left' : labelAlignment[alignment]};
  margin-top: 8px;
  margin-bottom: 8px;
  ${_ref => {
  let {
    bordered
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["bordered"]);

  return bordered && css`
      display: flex;
      justify-content: space-between;
      padding: 15px;
      background-color: ${getBackgroundColor('white')(props)};
      border-radius: 6px;
      border-width: 1px;
      border-style: solid;
      border-color: ${getBorderColor('light')(props)};

      ${getMediaQuery('large')} {
        cursor: pointer;
      }
    `;
}}

  ${getMediaQuery('large')} {
    svg {
      transform: rotate(90deg);
    }
  }
`;
export const AttributeList = styled(Flex).attrs(({
  alignment,
  gap
}) => ({
  justifyContent: alignment,
  rowGap: 2,
  columnGap: gap || 2
}))`
  flex-flow: row wrap;

  ${({
  smoothable
}) => smoothable && css`
      overflow: hidden;
      height: 105px;
    `};
`;